import { env } from 'env';
import { IMediumApiResponse } from 'types/api-responses';
import { useFetch } from './useFetch';

export const useBlogPageData = () =>
  useFetch<IMediumApiResponse>(env.REACT_APP_MEDIUM_API);
